// helper functions
export const checkForValue = value => value === 0 || (!!(value) && value !== Infinity && value !== 'N/A' && value !== 'NA')
export const truncate = (str, max = 30) => {
	let maxClean = Math.round(max)
	return str.length <= maxClean || str.indexOf(' ') > maxClean || !~str.indexOf(' ')
		? str
		: str[maxClean] === ' '
			? str.slice(0, maxClean)+'...'
			: truncate(str.slice(0, maxClean), maxClean - 1)
}